// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React from "react";
import { connect } from "react-redux";

import type { AppState } from "src/types";
import * as emailModalStages from "src/constants/emailModalStages";
import {
  hasRecipients,
  hasNonOrgRecipients,
  uploadingAttachment,
} from "src/reducers";
import { sendEmail } from "src/actions/email";
import { setEmailModalStage } from "src/actions/modal";

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Button,
  IconButton,
  HStack,
  VStack,
} from "@chakra-ui/react";
import { CloseIcon } from "@chakra-ui/icons";

import Recipients from "./Recipients";
import Subject from "./Subject";
import Message from "./Message";
import AttachmentsButton from "./AttachmentsButton";
import Attachments from "./Attachments";

import * as styles from "./styles";

type Props = {
  open: boolean,
  sending: boolean,
  uploading: boolean,
  hasRecipients: boolean,
  hasNonOrgRecipients: boolean,
  sendEmail: Function,
  inviteParticipants: Function,
  discard: Function,
};

function Email({
  open,
  sending,
  uploading,
  hasRecipients,
  hasNonOrgRecipients,
  sendEmail,
  inviteParticipants,
  discard,
}: Props) {
  return (
    <Modal isOpen={open} {...styles.modal}>
      <ModalOverlay />
      <ModalContent {...styles.content}>
        <ModalHeader {...styles.header}>
          {i18n.t(k.SEND_AS_EMAIL)}
          <IconButton
            {...styles.closeIconButton}
            icon={<CloseIcon {...styles.closeIcon} />}
            onClick={discard}
          />
        </ModalHeader>
        <ModalBody {...styles.body}>
          <VStack alignItems="start" spacing={3} height="100%">
            <Recipients />
            <Subject />
            <VStack
              alignItems="start"
              justifyContent="space-between"
              spacing={2}
              width="100%"
              height="100%"
              overflow="auto"
            >
              <Message />
              <Attachments />
            </VStack>
          </VStack>
        </ModalBody>

        <ModalFooter {...styles.footer}>
          <HStack position="relative">
            <AttachmentsButton />
            <Button variant="ghost" onClick={discard} isDisabled={sending}>
              {i18n.t(k.DISCARD)}
            </Button>
            <Button
              onClick={hasNonOrgRecipients ? inviteParticipants : sendEmail}
              isDisabled={!hasRecipients || uploading}
              isLoading={sending}
              variant="uBlueFilled"
            >
              {i18n.t(k.SEND)}
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

const mapStateToProps = ({ app }: { app: AppState }) => ({
  open: app.email.stage === emailModalStages.WRITE,
  sending: app.email.sending,
  uploading: uploadingAttachment(app),
  hasRecipients: hasRecipients(app),
  hasNonOrgRecipients: hasNonOrgRecipients(app),
});

const mapDispatchToProps = {
  sendEmail: () => sendEmail(true),
  discard: () => setEmailModalStage(null),
  inviteParticipants: () => setEmailModalStage(emailModalStages.INVITE),
};

export default connect(mapStateToProps, mapDispatchToProps)(Email);
